/** Minimaler Klassen-Joiner. Wird durch clsx + tailwind-merge ersetzt, sobald shadcn/ui einzieht. */
export function cn(...parts) {
    return parts.filter(Boolean).join(' ');
}
//# sourceMappingURL=cn.js.map